import { ca } from '@cian/analytics';

import { TOffer } from '../../types/offer';
import { getProducts } from '../../utils/trackings_helpers';

export function trackMoreMenuMoveToArchiveClick(offer?: TOffer, opponentId?: number, chatId?: string) {
  ca('eventSite', {
    action: 'moreMenu_move_to_archive',
    category: 'Chat',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
      },
    },
  });
}

export function trackMoreMenuMoveToSpamClick(offer?: TOffer, opponentId?: number) {
  ca('eventSite', {
    action: 'moreMenu_mark_message_as_spam',
    category: 'Chat',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}

export function trackMoreMenuClick(offer?: TOffer, opponentId?: number) {
  ca('eventSite', {
    action: 'moreMenu',
    category: 'Chat',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
}
